import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import VueQrcode from '@chenfengyuan/vue-qrcode';

import './assets/iconfont/iconfont.css'
createApp(App).use(store).use(router).use(ElementPlus).component(VueQrcode.name, VueQrcode).mount('#app')
